import Phaser from 'phaser';
import { SCENE_KEYS } from '../config';

export class DefeatScene extends Phaser.Scene {
  constructor() { super({ key: 'DefeatScene' }); }

  create(data: { title?: string; text?: string }): void {
    const { width, height } = this.cameras.main;
    this.cameras.main.setBackgroundColor('#1a0a0a');

    const title = data.title || 'TE ATRAPARON';
    const text = data.text || 'El CDR te denunció.\nIntenta de nuevo, ¡esta vez con más piedras!';

    // Silueta de edificio CDR
    this.drawCDRBuilding(width, height);

    // Título rojo con shake
    const titleObj = this.add.text(width / 2, height * 0.18, title, {
      fontSize: '44px', fontFamily: 'Arial Black, Impact, sans-serif',
      color: '#ff4444', stroke: '#000', strokeThickness: 4,
    }).setOrigin(0.5);
    this.tweens.add({ targets: titleObj, x: '+=3', duration: 50, yoyo: true, repeat: 6 });

    // Texto con typewriter
    const bodyText = this.add.text(width / 2, height * 0.5, '', {
      fontSize: '18px', fontFamily: 'Arial, sans-serif',
      color: '#ffaaaa', lineSpacing: 8,
      wordWrap: { width: width * 0.7 }, align: 'center',
    }).setOrigin(0.5);

    let idx = 0;
    const typeTimer = this.time.addEvent({
      delay: 35,
      repeat: text.length - 1,
      callback: () => { idx++; bodyText.setText(text.substring(0, idx)); },
    });

    // Retry
    const retryBtn = this.add.text(width / 2, height * 0.78, 'REINTENTAR', {
      fontSize: '24px', fontFamily: 'Arial Black, sans-serif',
      color: '#ff6666', backgroundColor: '#00000066',
      padding: { x: 20, y: 8 },
    }).setOrigin(0.5).setDepth(10).setInteractive({ useHandCursor: true });
    this.tweens.add({ targets: retryBtn, alpha: 0.4, duration: 800, yoyo: true, repeat: -1 });

    // Skip
    const skipBtn = this.add.text(width - 20, height - 20, 'SKIP ▶▶', {
      fontSize: '16px', fontFamily: 'monospace', color: '#888',
      backgroundColor: '#00000066', padding: { x: 8, y: 4 },
    }).setOrigin(1, 1).setDepth(10).setInteractive({ useHandCursor: true });

    const retry = () => { this.scene.start(SCENE_KEYS.GAME); };

    retryBtn.on('pointerdown', retry);
    skipBtn.on('pointerdown', () => { typeTimer.remove(); bodyText.setText(text); });
    this.input.keyboard?.on('keydown-ENTER', retry);
    this.input.keyboard?.on('keydown-SPACE', retry);
    this.input.on('pointerdown', (ptr: Phaser.Input.Pointer) => {
      if (!skipBtn.getBounds().contains(ptr.x, ptr.y) && !retryBtn.getBounds().contains(ptr.x, ptr.y) && idx >= text.length) retry();
    });
  }

  private drawCDRBuilding(w: number, h: number): void {
    const g = this.add.graphics();
    const baseY = h * 0.65;
    // Edificio oscuro
    g.fillStyle(0x1a0a0a);
    g.fillRect(w * 0.35, baseY - 180, 80, 180);
    g.fillRect(w * 0.55, baseY - 140, 70, 140);
    // Ventanas
    g.fillStyle(0x3a1a1a);
    for (let wy = baseY - 160; wy < baseY - 20; wy += 30) {
      for (let wx = w * 0.37; wx < w * 0.35 + 70; wx += 20) {
        g.fillRect(wx, wy, 10, 14);
      }
    }
    // Bandera roja
    g.fillStyle(0xcc2222);
    g.fillRect(w * 0.48, baseY - 200, 4, 30);
    g.fillRect(w * 0.48, baseY - 200, 25, 16);
  }
}
